<template>
  <div
    class="status-btn"
    :class="comClassName"
    @click="$emit('click')">
    {{text}}
  </div>
</template>

<script>
export default {
  props: {
    type: {
      validator: function(v) {
        return ['distributionState', 'privacyState', 'privacyStateDistributionState'].indexOf(v) !== -1
      }
    },
    distributionState: {
      type: Number,
      default: 1
    },
    privacyState: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 1,2,3
      btnText:[
        '已加入且公开',
        '已加入且私密',
        '未加入'
      ]
    }
  },
  computed: {
    stateValue() {
      if(this.privacyState == 0 && this.distributionState == 1) {
        return 1
      }
      if(this.privacyState == 1 && this.distributionState == 1) {
        return 2
      }
      if(this.distributionState == 2 || this.distributionState == 0) {
        return 3
      }
    },
    text() {
      return this.btnText[this.stateValue - 1]
    },
    comClassName() {
      return {
        distributionState: this.stateValue === 1 ||  this.stateValue === 2,
        privacyState: this.stateValue === 3,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-btn {
  width: 85px;
  height: 24px;
  line-height: 24px;
  border: 1px solid;
  border-radius: 2px;
  text-align: center;
  font-size: 12px;
  & + & {
    margin-top: 8px;
  }
}
.distributionState {
  cursor: pointer;
  border-color: #c2eaae;
  color: #78d14f;
  background: #e9f8e1;

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
}
.privacyState {
  cursor: pointer;
  border-color: #fde1a8;
  color: #fbb832;
  background: #fff4df;
  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>